
import { defineComponent, PropType } from 'vue';
import { LayoutSlot } from './layout-grid';
import { isEmpty } from '@/utils/misc';

/** @deprecated THIS COMPONENT IS FROZEN **/
export default defineComponent({
  name: 'LayoutGrid',
  provide() {
    return {
      $grid: this,
    };
  },
  props: {
    layout: {
      type: Array as PropType<LayoutSlot[]>,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: {
    edit: (index: number) => true,
    delete: (index: number) => true,
    add: (index: number) => true,
  },
  data() {
    return {
      widgetIndices: [] as number[],
    };
  },
  mounted() {
    this.refreshWidgets();
  },
  methods: {
    refreshWidgets() {
      this.widgetIndices = Object.entries(this.$slots)
        .filter(([_, slots]) => !isEmpty(slots))
        .map(([name, _]) => +name.replace('widget-', ''));
    },

    getSlotTabletRowClasses(index: number, height: number): string[] {
      if (this.editMode) {
        return [];
      }

      const startRow = this.getSlotStartRowOnTablet(index);
      return [
        `tablet-row-from-${startRow}`,
        `tablet-row-to-${startRow + height}`,
      ];
    },

    getSlotStartRowOnTablet(index: number): number {
      // Adjust index to slotsWithWidget
      const adjustedIndex =
        index - this.getNumberOfEmptySlotsBeforeIndex(index);

      return (
        this.slotsWithWidget
          .map((slot) => slot.height)
          .slice(0, adjustedIndex)
          .reduce((total: number, height: number) => total + height, 0) + 1
      );
    },

    getNumberOfEmptySlotsBeforeIndex(index: number) {
      return this.layout
        .slice(0, index)
        .filter((_, i) => !this.isThereWidgetInSlot(i)).length;
    },

    isThereWidgetInSlot(index: number): boolean {
      return this.widgetIndices.includes(index);
    },
  },
  computed: {
    slotsWithWidget(): LayoutSlot[] {
      return this.layout.filter((_, index) => this.isThereWidgetInSlot(index));
    },

    tabletRowsCount(): number {
      return this.slotsWithWidget
        .map((slot) => slot.height)
        .reduce((total: number, height: number) => total + height, 0);
    },
  },
});
